import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseAntiVirus from '../../AbstractObjects/GatewayPlan/InnerPages/BaseAntiVirus';

const pageSchema = PlanGetSchema.pages.antiVirus;
const pageId = pageSchema.pageId;

function PlanAntiVirus({
    planObject,
    setPlanData,
    setEditorPageId
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseAntiVirus
            pageData={pageData}
            setObjectData={setPlanData}
            setEditorPageId={setEditorPageId}
        />
    );
}

export default PlanAntiVirus;